// extracted by mini-css-extract-plugin
export default {"infoRow":"I44I1Aotzb6BwbWSquyh","consumedCell":"APqc0Fz1LNC6MlHfzHyG","divider":"vJ2_U5Zmn8YU5PF_Uvje","description":"QwV3PxS7sITw7JmvkKiY"};